import BaseService from '@/ecm/common/BaseService.js'

class ParameterService {
  baseUrl = 'parameter';

  getAll = () => BaseService.get({ url: `${this.baseUrl}/get-all` });
  save = (parameters) => BaseService.post({ url: `${this.baseUrl}/save`, data: parameters });
  getLog = (filter) => BaseService.post({ url: `${this.baseUrl}/get-log`, data: filter });
  generateSAD = () => BaseService.post({ url: `${this.baseUrl}/generate-sad`});
  getSADExpiration = () => BaseService.get({ url: `${this.baseUrl}/get-sad-expiration`});
}

export default new ParameterService()
